/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "name": "Block Pinning",
  "description": "Pin your favourite Blocks to the top of the Toolbox.",
  "incompatible": ["toolbox-category-drag"],
  "credits": [
    {
      "name": "SharkPool",
      "link": "https://github.com/SharkPool-SP/"
    }
  ],
  "info": [
    {
      "type": "notice",
      "text": "Warning: Expect pinned Blocks with Checkboxes to behave weirdly when checked.",
      "id": "checkbox-notice"
    }
  ],
  "settings": [
    {
      "dynamic": false,
      "name": "Automatically load Extensions from pinned Blocks",
      "id": "autoLoadExts",
      "type": "boolean",
      "default": true
    }
  ],
  "userscripts": [
    { "url": "userscript.js" }
  ],
  "tags": [
    "editor",
    "new"
  ],
  "enabledByDefault": false,
};
export default manifest;
